import { render, staticRenderFns } from "./OrderFilter.vue?vue&type=template&id=6a8f63b4&scoped=true"
import script from "./OrderFilter.vue?vue&type=script&lang=ts"
export * from "./OrderFilter.vue?vue&type=script&lang=ts"
import style0 from "./OrderFilter.vue?vue&type=style&index=0&id=6a8f63b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f63b4",
  null
  
)

export default component.exports